import apiServices from "../../ApiServices/request-handler";
import { requestHandler } from "../../utils/functions";
import { setOtpToken } from "../slices/authSlice";
import { setCommonLoading, setOtpTimer } from "../slices/commonSlice";

export const generateGeneralOtp = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.generateGeneralOtp,
        param_data: params,
        setLoading: setCommonLoading,
        isSuccessMessage: true,
        onDone: (response) => {
          const time = !isNaN(Number(response?.result?.otpTimer)) ? Number(response?.result?.otpTimer) * 60 : 60;
          dispatch(setOtpTimer(time));
          onDone && onDone(response);
        },
      })
    );
  };
};

export const verifyGeneralOtp = (data, onDone, onError) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.verifyGeneralOtp,
        param_data: data,
        setLoading: setCommonLoading,
        onDone: (val) => {
          dispatch(setOtpToken(val?.result?.otpVerificationToken));
          onDone && onDone();
        },
        onError: (err) => onError(err?.data),
      })
    );
  };
};
